import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useEffect, useRef, useState, } from "react";
import { Box, Typography, Grid, Accordion, AccordionSummary, AccordionDetails, Autocomplete, TextField, FormControlLabel, Checkbox, useMediaQuery, useTheme, } from "@mui/material";
import { useTranslation } from "react-i18next";
import CustomModal from "../modal/CustomModal";
import { CaretDown } from "@phosphor-icons/react";
import OfferLeadObject from "./OfferLeadObject";
import OfferLeadObjectPrice from "./OfferLeadObjectPrice";
import LeadDetailApi from "../../../infrastructure/api/pages/lead-detail-api";
import ContractApi from "../../../infrastructure/api/pages/contract-api";
import { toast } from "react-toastify";
import { convertToNLEuroFormat } from "../../../application/common/utils/helper";
import ConfirmDialog from "../../components/ConfirmDialog";
const OfferModal = ({ open, onClose, leadId, refresh, setRefreshModalData, setObjectModal, setActionTabRefresh, leadObjects, setLeadObjects, setStatusSectionRefresh, }) => {
    const [selectedObjects, setSelectedObjects] = useState([]);
    const [isContractContinous, setIsContractContinous] = useState(false);
    const [contacts, setContacts] = useState([]);
    const [contactOptions, setContactOptions] = useState([]);
    const [error, setError] = useState(undefined);
    const [totalAmount, setTotalAmount] = useState(0);
    const [isSeprateContract, setIsSeprateContract] = useState(false);
    const [isDisabled, setIsDisabled] = useState(false);
    const [showSendConfirm, setShowSendConfirm] = useState(false);
    const contactSelectRef = useRef(null);
    // const [leadObjects, setleadObjects] = useState<LeadObjectDto[]>(leadObjectsProp);
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
    const isTablet = useMediaQuery(theme.breakpoints.between("sm", "md"));
    const GetLeadContacts = () => {
        if (leadId) {
            LeadDetailApi.getLeadContacts(leadId)
                .then((response) => {
                if (response.status === 200 && response.data != null) {
                    setContacts(response.data);
                }
            })
                .finally(() => { });
        }
    };
    useEffect(() => {
        if (contacts && contacts.length > 0) {
            if (contacts.length > 0) {
                const op = contacts.map((item) => {
                    return {
                        id: item.id,
                        label: item.name,
                        // map other properties if needed
                    };
                });
                setContactOptions(op);
            }
        }
    }, [contacts]);
    const [saving, setSaving] = useState(false);
    const { t: translate } = useTranslation();
    const [selectedContact, setSelectedContact] = useState(null);
    const handleAutocompleteChange = (event, newValue) => {
        setSelectedContact(newValue);
        if (!newValue) {
            setIsDisabled(true);
            setError("Vereist");
        }
        else {
            const foundItem = checkIfEmailNotNull(newValue === null || newValue === void 0 ? void 0 : newValue.id);
            if (foundItem) {
                setIsDisabled(false);
            }
            else {
                toast.warning(translate("Email address of this contact person is empty"));
                setIsDisabled(true);
            }
            setError(undefined);
        }
    };
    const checkIfEmailNotNull = (id) => {
        return contacts.find((item) => { var _a; return item.id === id && item.email !== null && ((_a = item.email) === null || _a === void 0 ? void 0 : _a.trim()) !== ""; });
    };
    const handleSaveButtonClick = () => {
        var _a;
        // Client feedback #11.1: hard-block sending an offer worth €0 — checked before
        // the confirmation popup so the user isn't asked to confirm an action that's
        // already known to be invalid.
        if (totalAmount <= 0) {
            toast.error(translate("OfferValueCannotBeZero"));
            return;
        }
        // Trigger click event on the hidden button
        if (selectedContact === null || selectedContact === void 0 ? void 0 : selectedContact.id) {
            if (leadId) {
                setShowSendConfirm(true);
            }
        }
        else {
            setError("Vereist");
            (_a = contactSelectRef === null || contactSelectRef === void 0 ? void 0 : contactSelectRef.current) === null || _a === void 0 ? void 0 : _a.focus();
        }
    };
    // Only invoked via the confirm dialog's onConfirm, which only shows after
    // handleSaveButtonClick has already validated the zero-value check, contact
    // selection, and leadId — no need to re-check them here.
    const sendOffer = () => {
        setShowSendConfirm(false);
        // Iterate over each object in the source array
        leadObjects.forEach((sourceObj) => {
            // Find the corresponding object in the target array using its ID
            const targetIndex = selectedObjects.findIndex((targetObj) => targetObj.objectId === sourceObj.id);
            // If the object is found, update it with data from the source object
            if (targetIndex !== -1) {
                selectedObjects[targetIndex] = Object.assign(Object.assign({}, selectedObjects[targetIndex]), sourceObj);
            }
        });
        const mappedObjects = selectedObjects.map((obj) => ({
            objectId: obj.objectId, // or obj.objectId depending on which is the correct ID
            price: obj.price,
            updatedPrice: obj.updatedPrice,
        }));
        var contract = {
            leadId: leadId,
            objects: mappedObjects,
            isDeleted: false,
            contactId: selectedContact === null || selectedContact === void 0 ? void 0 : selectedContact.id,
            isSigned: false,
            name: "",
            functie: "",
            remark: "",
            payLater: true,
            contactMe: true,
            informationSubmitted: false,
            isContinous: isContractContinous,
            isCopied: false,
            consultancyNewsLetter: true,
            installationNewLetter: true,
            productsNewLetter: true,
            trainingNewLetter: true,
            inpectionNewLetter: true,
            inspectionPDF: "",
            isSeprateContract: isSeprateContract,
        };
        setSaving(true);
        ContractApi.add(contract)
            .then((response) => {
            if (response.status === 200 && response.data != null) {
                toast.success("Offerte succesvol verzonden.");
                onCloseModal();
            }
        })
            .catch((error) => {
            var _a, _b;
            toast.error(((_b = (_a = error === null || error === void 0 ? void 0 : error.response) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.message) ||
                "Er is iets misgegaan bij het versturen van de offerte.");
        })
            .finally(() => {
            setSaving(false);
            setRefreshModalData((prev) => !prev);
            setObjectModal((prev) => !prev);
            setActionTabRefresh((prev) => !prev);
            setStatusSectionRefresh((prev) => !prev);
            setIsContractContinous(false);
        });
    };
    const onCloseModal = () => {
        setSelectedObjects([]);
        setSelectedContact(null);
        setError(undefined);
        // GetLeadObjectById(leadId);
        onClose();
    };
    useEffect(() => {
        if (leadId) {
            GetLeadContacts();
            // GetLeadObjectById(leadId);
        }
    }, [leadId, refresh]);
    //Update lead object prices
    const updatePriceOfLeadObject = (index, updatedItem) => {
        setLeadObjects((prevItems) => {
            const updatedItems = [...prevItems]; // Create a copy of the original array
            updatedItems[index] = updatedItem; // Replace the item at the specified index
            return updatedItems; // Update the state with the modified array
        });
    };
    useEffect(() => {
        if (leadObjects && leadObjects.length > 0 && selectedObjects.length > 0) {
            setTotalAmount(leadObjects
                .filter((item) => selectedObjects.map((obj) => obj.objectId).includes(item.id))
                .reduce((total, current) => { var _a; return total + ((_a = current.updatedPrice) !== null && _a !== void 0 ? _a : current.price); }, 0));
        }
        else {
            setTotalAmount(0);
        }
    }, [leadObjects, selectedObjects]);
    const hasZeroPriceSelectedObject = leadObjects
        .filter((item) => selectedObjects.map((obj) => obj.objectId).includes(item.id))
        .some((item) => { var _a; return ((_a = item.updatedPrice) !== null && _a !== void 0 ? _a : item.price) === 0; });
    const handleCheckboxChange = (event) => {
        const { checked } = event.target;
        setIsContractContinous(checked);
    };
    const handleSeprateContractCheckboxChange = (event) => {
        const { checked } = event.target;
        setIsSeprateContract(checked);
    };
    return (_jsxs(_Fragment, { children: [_jsxs(CustomModal, { open: open, onClose: onCloseModal, size: "lg", saving: saving, handleSaveButtonClick: handleSaveButtonClick, heading: translate("SendQuote"), saveButtonText: translate("SendQuote"), disabled: selectedObjects.length <= 0 ||
                    (selectedObjects.length > 0 && isDisabled) ||
                    (selectedObjects.length > 0 && !selectedContact) ||
                    (selectedObjects.length > 0 && totalAmount <= 0) ||
                    hasZeroPriceSelectedObject ||
                    saving, disabledTooltip: hasZeroPriceSelectedObject
                    ? translate("OfferItemZeroPriceTooltip")
                    : undefined, warningMessage: (leadObjects === null || leadObjects === void 0 ? void 0 : leadObjects.some((obj) => obj.isContracted === true))
                    ? translate("Quote has been sent")
                    : undefined, children: [_jsxs(Grid, { container: true, spacing: 0, sx: {
                            gap: 2,
                            paddingTop: "16px",
                            paddingX: isMobile ? "8px" : isTablet ? "16px" : "24px"
                        }, children: [_jsx(Autocomplete, { disablePortal: true, id: "combo-box-demo", options: contactOptions, onChange: handleAutocompleteChange, sx: {
                                    width: isMobile ? "100%" : "300px",
                                    display: "block !important",
                                }, noOptionsText: translate("noOptions"), renderInput: (params) => (_jsx(TextField, Object.assign({}, params, { label: "Select Contact", error: !!error, helperText: error, inputRef: contactSelectRef }))) }), _jsxs(Grid, { container: true, size: 12, children: [_jsx(Grid, { className: "checkbox-container", size: {
                                            xs: 12,
                                            sm: 5,
                                            md: 3
                                        }, children: _jsx(FormControlLabel, { control: _jsx(Checkbox, { checked: isContractContinous, onChange: handleCheckboxChange }), label: _jsx(Typography, { className: "checkbox-text", children: "Doorlopend contract" }) }) }), _jsx(Grid, { className: "checkbox-container", size: {
                                            xs: 12,
                                            sm: 5,
                                            md: 3
                                        }, children: _jsx(FormControlLabel, { control: _jsx(Checkbox, { checked: isSeprateContract, onChange: handleSeprateContractCheckboxChange }), label: _jsx(Typography, { className: "checkbox-text", children: translate("SeparateContract") }) }) })] }), leadObjects === null || leadObjects === void 0 ? void 0 : leadObjects.map((leadobject, index) => (_jsx(OfferLeadObject, { leadobject: leadobject, setSelectedObjects: setSelectedObjects, selectedObjects: selectedObjects }, leadobject.id)))] }), _jsxs(Accordion, { sx: {
                            position: "sticky",
                            bottom: { xs: "-1px", sm: "-1px" },
                            borderBottomLeftRadius: "0 !important",
                            borderBottomRightRadius: "0 !important",
                            padding: { xs: "4px 3px", md: "16px 12px" },
                            width: "100%",
                        }, children: [_jsx(AccordionSummary, { expandIcon: _jsx(CaretDown, { size: 24 }), "aria-controls": "panel2-content", id: "panel2-header", children: _jsxs(Grid, { container: true, size: 12, sx: {
                                        justifyContent: "space-between",
                                        width: "100%"
                                    }, children: [_jsx(Grid, { children: _jsx(Typography, { variant: "h6", sx: { fontWeight: "500 !important" }, children: translate("TotalAmount") }) }), _jsx(Grid, { sx: {
                                                paddingRight: "15px"
                                            }, children: _jsx(Box, { sx: {
                                                    display: "flex",
                                                    borderRadius: "var(--1, 8px)",
                                                    width: "fit-content",
                                                    background: "rgba(42, 162, 65, 0.10)",
                                                    padding: "var(--borderRadius, 4px) var(--2, 16px)",
                                                    justifyContent: "center",
                                                    alignItems: "center",
                                                }, children: _jsx(Typography, { sx: {
                                                        color: "var(--Status-Success, #2AA241)",
                                                        fontSize: "16px",
                                                        fontStyle: "normal",
                                                        fontWeight: 500,
                                                        lineHeight: "150%",
                                                        letterSpacing: "1px",
                                                    }, children: convertToNLEuroFormat(parseFloat(totalAmount.toFixed(1))) }) }) })] }) }), _jsx(AccordionDetails, { children: _jsx(Grid, { container: true, children: _jsxs(Grid, { sx: {
                                            display: "flex",
                                            padding: "var(--none, 0px)",
                                            flexDirection: "column",
                                            alignItems: "flex-start",
                                            gap: { sx: 1.5, md: 3 },
                                            alignSelf: "stretch",
                                        }, size: 12, children: [leadObjects.map((leadObject, index) => {
                                                if (selectedObjects
                                                    .map((obj) => obj.objectId)
                                                    .includes(leadObject.id)) {
                                                    return (_jsx(OfferLeadObjectPrice, { leadObject: leadObject, index: index, updatePriceOfLeadObject: updatePriceOfLeadObject }, leadObject.id));
                                                }
                                                return null;
                                            }), _jsxs(Grid, { container: true, size: 12, sx: {
                                                    justifyContent: "space-between",
                                                    borderTop: "0.5px solid var(--n-teal-dark, #4D666E)",
                                                    paddingTop: "10px"
                                                }, children: [_jsx(Grid, { children: _jsx(Typography, { variant: "h6", sx: { fontWeight: "500 !important" }, children: translate("TotalAmount") }) }), _jsx(Grid, { sx: {
                                                            paddingRight: "32px"
                                                        }, children: _jsx(Typography, { variant: "body1", sx: {
                                                                color: "var(--n-jetblack, #312F2F)",
                                                                fontWeight: 500,
                                                                paddingRight: "15px !important"
                                                            }, children: convertToNLEuroFormat(parseFloat(totalAmount.toFixed(1))) }) })] })] }) }) })] })] }), _jsx(ConfirmDialog, { open: showSendConfirm, title: translate("SendQuote"), message: translate("SendQuoteConfirmation"), onClose: () => setShowSendConfirm(false), onConfirm: sendOffer, loading: saving })] }));
};
export default OfferModal;
